import { axiosInstance } from '@/plugins/axios';

const aciton = {
  push: 'candao.orderOwn.postOrder', // 提交订单
  getter: 'candao.orderOwn.getOrderDetail', // 获取订单详情
  list: 'candao.orderOwn.getBrandOrders', // 获取订单列表
  cancel: 'candao.orderOwn.cancelOrder', // 取消订单
  finish: 'candao.orderOwn.finishOrder', // 完成订单
  call: 'candao.orderOwn.callOrder', // 用户催单
  application: 'candao.orderOwn.addVerifyCancelOrder', // 用户申请/撤销取消订单审核
  pay: 'candao.pay.orderPay', // 订单支付
};

// 公用请求方法
const common = ({ actionName, method = 'mothod', ...data }) => axiosInstance({
  method: 'post',
  url: 'SecretAction',
  params: {
    method,
  },
  data: {
    actionName,
    ...data,
  },
});

const appointTimes = {
  timerEX: 15,
  block1(paramsH1, paramsM1, h2, m2) {
    let m1 = paramsM1;
    let h1 = paramsH1;
    let dateM1 = m1;
    let dateH1 = h1;
    if (m1 < (60 - this.timerEX)) {
      dateM1 += this.timerEX;
    } else {
      dateM1 += this.timerEX - 60;
      dateH1 += 1;
    }
    if (h1 < 10) {
      h1 = `0${h1}`;
    }
    if (m1 < 10) {
      m1 = `0${m1}`;
    }
    if ((dateH1 * 60 + dateM1) <= (h2 * 60 + m2)) {
      return [`${h1}:${m1}:00`].concat(this.block1(dateH1, dateM1, h2, m2));
    }
    return `${h1}:${m1}:00`;
  },
  change(times) {
    let timesTmp = [];
    times.forEach((dTime) => {
      const temp1 = dTime.split('~');
      const temp2N0 = temp1[0].split(':');
      temp2N0[0] = parseInt(temp2N0[0], 10);
      temp2N0[1] = parseInt(temp2N0[1], 10);
      const temp2N1 = temp1[1].split(':');
      temp2N1[0] = parseInt(temp2N1[0], 10);
      temp2N1[1] = parseInt(temp2N1[1], 10);

      timesTmp = timesTmp.concat(this.block1(temp2N0[0], temp2N0[1], temp2N1[0], temp2N1[1]));
    });
    return timesTmp;
  },
};

// 订单相关接口
const order = {
  changeTimes: times => appointTimes.change(times),
  pay: ({ actionName = aciton.pay, ...data }) => common({ actionName, method: 'orderPay', ...data }), // 订单支付
  push: ({ actionName = aciton.push, ...data }) => common({ actionName, method: 'postOrder', ...data }), // 提交订单
  getter: ({ actionName = aciton.getter, ...data }) => common({ actionName, method: 'getOrderDetail', ...data }), // 获取订单详情
  list: ({ actionName = aciton.list, ...data }) => common({ actionName, method: 'getBrandOrders', ...data }), // 获取订单列表
  cancel: ({ actionName = aciton.cancel, ...data }) => common({ actionName, method: 'cancelOrder', ...data }), // 取消订单
  finish: ({ actionName = aciton.finish, ...data }) => common({ actionName, method: 'finishOrder', ...data }), // 完成订单
  call: ({ actionName = aciton.call, ...data }) => common({ actionName, method: 'callOrder', ...data }), // 用户催单
  application: ({ actionName = aciton.application, ...data }) => common({ actionName, method: 'addVerifyCancelOrder', ...data }), // 用户申请/撤销取消订单审核
};

export default order;
